// ============================================================================
//  SINGLE SOURCE OF TRUTH FOR BRANDING
//  To launch this design as a NEW site, change ONLY the values below
//  (logo, name, contact, domain). Everything on the frontend reads from here.
//
//  Also update, for a full rebrand:
//   • /app/frontend/public/index.html  (title, description, JSON-LD, favicon, GSC tag)
//   • /app/backend/.env  (COMPANY_NAME, COMPANY_PHONE, COMPANY_LOGO, COMPANY_WEBSITE,
//                         COMPANY_ADDRESS, ADMIN_NOTIFY_EMAILS, GMAIL_USER, ...)
// ============================================================================

const NAME = "Airport Taxi Transfers";
const DOMAIN = "airporttaxitransfers.ch"; // no protocol, no trailing slash
const LOGO =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_taxi-zurich-flight/artifacts/a4s3pxgk_airporttaxi%20logo%209.png";

// Phone in international format; digits-only version is derived automatically.
const PHONE = "+41 44 594 2112";
const EMAIL = "Info@airporttaxitransfers.ch";
const ADDRESS = "Flughafenstrasse 1, 8302 Kloten";

// WhatsApp uses a mobile number (office landline can't receive WhatsApp).
const WHATSAPP_PHONE = "+41 79 177 24 24";

// All public phone numbers (shown in header + footer). First = primary.
const PHONES = [
  { number: "+41 44 594 2112", label: "Büro" },
  { number: "+41 79 177 24 24", label: "" },
  { number: "+41 76 389 64 52", label: "" },
];

// ---- derived (no need to edit) ----
const PHONE_DIGITS = PHONE.replace(/[^\d+]/g, "");
const WA_NUMBER = WHATSAPP_PHONE.replace(/[^\d]/g, "");
const PHONE_LIST = PHONES.map((p) => ({
  ...p,
  href: `tel:${p.number.replace(/[^\d+]/g, "")}`,
}));

export const BRAND = {
  name: NAME,
  logo: LOGO,
  phone: PHONE,
  phoneHref: `tel:${PHONE_DIGITS}`,
  phones: PHONE_LIST,
  whatsapp: `https://wa.me/${WA_NUMBER}`,
  email: EMAIL,
  emailHref: `mailto:${EMAIL}`,
  address: ADDRESS,
  addressMap: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ADDRESS)}`,
  domain: DOMAIN,
};

// Base URL used for SEO canonical/OG tags.
export const SEO_BASE = `https://${DOMAIN}`;
export const DEFAULT_OG_IMAGE = LOGO;
